<template>
  <section class="questions-panel" aria-label="Konuşma soruları">
    <div class="question-book mb-3">
      <img src="../../../assets/images/book/book-title-logo.png" alt="" class="book-title-logo">
      <div class="book-titles">
        <span class="book-title">{{ bookTitle?.bookParentTitle }}</span>
        <span class="book-title-2">{{ bookTitle?.bookSubTitle }}</span>
        <span class="book-sub-title">Conversation Questions</span>
      </div>
    </div>
    <SubjectBookImage v-if="sectionImageUrl" :url="sectionImageUrl" banner alt="Konuşma soruları bölümü görseli" />
    <template v-if="items.length">
      <div class="questions-toolbar">
        <label>Dinleme hızı <select v-model.number="speed"><option :value="0.75">0,75×</option><option :value="1">Normal</option><option :value="1.25">1,25×</option></select></label>
        <ContentLanguageSwitch v-if="hasTranslation" :language="language" @language="selectLanguage" />
      </div>
      <div class="question-list">
        <QuestionPracticeCard v-for="(question, index) in items" :key="index" ref="cards" :content="question" :number="index + 1" :speed="speed" :language="language" @focus="focusQuestion(index + 1)" />
      </div>
    </template>
    <p v-else class="empty" role="status">Bu konuya ait soru bulunamadı.</p>
  </section>
</template>
<script>
import '../../../assets/styles/book-design.css';
import QuestionPracticeCard from './QuestionPracticeCard.vue';
import SubjectBookImage from './SubjectBookImage.vue';
import ContentLanguageSwitch from './ContentLanguageSwitch.vue';
export default {
  name: 'TabQuestion',
  components: {QuestionPracticeCard, SubjectBookImage, ContentLanguageSwitch},
  props: {sectionImageUrl: {type: String, default: ''}, questions: {type: Array, default: () => []}, bookTitle: {type: Object, default: () => ({})}},
  data() { return {speed: 1, language: 'en-EN'}; },
  computed: {
    items() { return (this.questions || []).filter(Boolean); },
    hasTranslation() { return this.items.some(question => question.languages?.some(item => item.languageCode === 'tr-TR' && item.question?.trim())); }
  },
  methods: {
    selectLanguage(language) { if (language === this.language) return; this.stopAudio(); this.language = language; },
    stopAudio() { (this.$refs.cards || []).forEach(card => card.stopAudio()); },
    focusQuestion(number) { (this.$refs.cards || []).forEach(card => { if (card.number !== number) card.stopAudio(); }); }
  },
  beforeUnmount() { this.stopAudio(); }
};
</script>
<style scoped>
.questions-panel { width: 100%; min-width: 0; }
.question-book { display: flow-root; }
.questions-toolbar { display: flex; justify-content: space-between; align-items: center; gap: 12px; margin-bottom: 20px; }
.questions-toolbar label { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; min-width: 0; color: #526174; font-size: 14px; }
select { min-height: 40px; border: 1px solid #e2e8f0; border-radius: 9px; padding: 8px; background: white; color: #20382d; }
select:focus-visible { outline: 3px solid var(--brand-primary-hover); outline-offset: 2px; }
.question-list { display: grid; gap: 20px; }
.empty { padding: 24px 0; color: #64748b; }
</style>
